import { render, staticRenderFns } from "./AdminAgentSearch.vue?vue&type=template&id=fa1565ec&"
import script from "./AdminAgentSearch.vue?vue&type=script&lang=ts&"
export * from "./AdminAgentSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports